class ctxTableTreeviewCheckboxHelperDirective {
    constructor() {
        this.restrict = 'A';
        this.scope = {
            node: '=ctxTableTreeviewCheckboxHelper'
        };
        this.require = '^ctxTableTreeview';
        this.template = [
            '<div class="checkbox table-tree-checkbox">',
                    '<input type="checkbox"',
                    'class="ivh-treeview-checkbox"',
                    'ng-model="isSelected"',
                    'ng-click="resolveIndeterminateClick()"',
                    'ng-change="trvw.select(node, isSelected)" />',
                '<label for="{{trvw.label(node)}}">',
                    '<span class="{{getIconType()}}"></span>',
                    '{{trvw.label(node)}}',
                    '<span class="white-block"></span>',
                '</label>',
            '</div>'
        ].join('\n');
    }

    link(scope, element, attrs, trvw) {
        const node = scope.node;
        const opts = trvw.opts();
        const indeterminateAttr = opts.indeterminateAttribute;
        const selectedAttr = opts.selectedAttribute;

        scope.isSelected = node[selectedAttr];
        scope.trvw = trvw;
        scope.opts = opts;

        scope.resolveIndeterminateClick = () => {
            if (node[indeterminateAttr]) {
                trvw.select(node, true);
            }
        };

        scope.getIconType = () => {
            return node.iconType;
        };

        scope.$watch('node.' + selectedAttr, newVal => {
            scope.isSelected = newVal;
        });

        scope.$watch('node.' + indeterminateAttr, newVal => {
            element.find('input').prop('indeterminate', newVal);
        });
    }

    static directiveFactory() {
        return new ctxTableTreeviewCheckboxHelperDirective();
    }
}

ctxTableTreeviewCheckboxHelperDirective.directiveFactory.$inject = [];

module.exports = ctxTableTreeviewCheckboxHelperDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/customDirectives/ctxTableTreeviewCheckboxHelper.directive.js